.scroller { height: 100%; overflow-y: auto; overflow-x: hidden; overscroll-behavior: contain; contain: strict; background: var(--color-surface); }
.row {
  position: absolute; left: 0; right: 0; top: 0;
  display: grid; grid-template-columns: auto minmax(120px, 200px) minmax(0, 1fr) auto; align-items: center; column-gap: var(--space-3);
  padding: 0 var(--space-4) 0 var(--space-2);
  border-bottom: 1px solid var(--color-border);
  font-size: var(--text-sm); color: var(--color-text-secondary); cursor: pointer;
  transition: background-color var(--duration-fast) ease;
}
.row:hover { background: var(--color-surface-hover); }
.unread { color: var(--color-text); }
.unread .fromName, .unread .subject { font-weight: var(--weight-semibold); }
.checked { background: var(--color-surface-selected); }
.open { background: var(--color-surface-selected); }
/* Keyboard cursor: inset ring in brand purple, the single "you are here" mark */
.row[data-cursor] { box-shadow: inset 0 0 0 1px var(--color-primary); }

.lead { display: flex; align-items: center; gap: var(--space-1); }
.check { width: 16px; height: 16px; margin: 0 var(--space-2); accent-color: var(--color-primary); cursor: pointer; }
.avatar { margin-right: var(--space-1); }
.star { display: grid; place-items: center; width: 28px; height: 28px; border: 0; border-radius: var(--radius-full); background: transparent; color: var(--color-text-muted); }
.star svg { width: 16px; height: 16px; }
.star:hover { background: var(--color-surface-sunken); color: var(--color-text); }
.starred { color: var(--color-star); }
.starred svg { fill: currentColor; }

.from { display: flex; align-items: center; gap: var(--space-1-5); min-width: 0; color: inherit; }
.fromName { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; color: var(--color-text); }
.row:not(.unread) .fromName { color: var(--color-text-secondary); }
.dot { flex: none; width: 7px; height: 7px; border-radius: var(--radius-full); background: var(--color-unread-dot); }
.count { flex: none; color: var(--color-text-muted); font-size: var(--text-xs); }

.body { display: flex; align-items: baseline; gap: var(--space-2); min-width: 0; overflow: hidden; white-space: nowrap; }
.subject { flex: none; max-width: 70%; overflow: hidden; text-overflow: ellipsis; color: var(--color-text); }
.row:not(.unread) .subject { color: var(--color-text-secondary); font-weight: var(--weight-medium); }
.noSubject { color: var(--color-text-muted) !important; font-weight: var(--weight-regular) !important; }
.snippet { min-width: 0; overflow: hidden; text-overflow: ellipsis; color: var(--color-text-muted); }
.snippet::before { content: "\2013\00a0"; }
.label {
  flex: none; align-self: center; padding: 1px var(--space-1-5); border-radius: var(--radius-xs);
  background: color-mix(in oklab, var(--hue) 12%, var(--color-surface)); color: var(--hue);
  font-size: var(--text-2xs); font-weight: var(--weight-semibold); line-height: 1.5;
}
:root[data-theme="dark"] .label { background: color-mix(in oklab, var(--hue) 26%, var(--color-surface)); color: color-mix(in oklab, var(--hue) 40%, white); }

.meta { display: flex; align-items: center; gap: var(--space-2); justify-self: end; font-size: var(--text-xs); color: var(--color-text-muted); }
.unread .meta { color: var(--color-text); font-weight: var(--weight-semibold); }
.clip { width: 14px; height: 14px; }

/* Comfortable: two lines (sender + date, subject + snippet) */
.comfortable .row { grid-template-columns: auto minmax(0, 1fr) auto; grid-template-rows: auto auto; row-gap: 2px; align-content: center; }
.comfortable .lead { grid-row: 1 / span 2; }
.comfortable .from { grid-column: 2; grid-row: 1; }
.comfortable .body { grid-column: 2 / span 2; grid-row: 2; }
.comfortable .meta { grid-column: 3; grid-row: 1; }
.compact .row { font-size: var(--text-sm); }
.compact .star { width: 24px; height: 24px; }

/* Narrow list pane (right split) or phone: two-line layout regardless of density */
.twoLine .row { grid-template-columns: auto minmax(0, 1fr) auto; grid-template-rows: auto auto; row-gap: 2px; align-content: center; }
.twoLine .lead { grid-row: 1 / span 2; }
.twoLine .from { grid-column: 2; grid-row: 1; }
.twoLine .body { grid-column: 2 / span 2; grid-row: 2; }
.twoLine .meta { grid-column: 3; grid-row: 1; }
.twoLine .check { display: none; }
